import React from 'react';
import { Steps, Breadcrumb, Layout, notification, Modal } from 'antd/lib';
import * as Icons from '@ant-design/icons';
import { graphql, compose, withApollo } from 'react-apollo';

const confirm = Modal.confirm;

import SelectorModelo from '../formularios/SelectorModelo';
import FormDeclaracionJurada from '../formularios/FormDeclaracionJurada';
import Generador from '../../generador/Generador';
import CKEditor from '../../editor/Example';
import Loading from '../../common/Loading';

import insertPersona from '../../../graphql/mutations/persona/insertPersona.graphql';
import insertDeclaracionJurada from '../../../graphql/mutations/tramites/insertDeclaracionJurada.graphql';
import crearDeclaracionJurada from '../../../graphql/mutations/tramites/crearDeclaracionJurada.graphql';
import confirmarDeclaracionJurada from '../../../graphql/mutations/tramites/confirmarDeclaracionJurada.graphql';
import obtenerNumeroTalonario from '../../../graphql/mutations/editor/obtenerNumeroTalonario.graphql';
import insertDetalleVenta from '../../../graphql/mutations/venta/insertDetalleVenta.graphql';
import insertVenta from '../../../graphql/mutations/venta/insertVenta.graphql';

import BuscarYCrearPersona from '../../procesos/BuscarYCrearPersona';

import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';

import { imprimir } from '../../common/funciones/imprimir';

import moment from 'moment';
import _ from 'lodash';
import { errorService } from '../../../graphql/utils/utils';
import { verPdf } from '../../common/funciones/verPdf';
const estiloContent = {
  marginTop: 16,
  border: '1px dashed #e9e9e9',
  borderRadius: 6,
  backgroundColor: '#fafafa',
  paddingTop: 20,
};

@compose(
  graphql(insertDeclaracionJurada, {
    name: 'createDeclaracion',
  }),
  graphql(crearDeclaracionJurada, {
    name: 'crearDeclaracionJurada',
  }),
  graphql(insertPersona, {
    name: 'createPers',
  }),
  graphql(confirmarDeclaracionJurada, {
    name: 'confirmarDeclaracionJurada',
  }),
  graphql(insertDetalleVenta, {
    name: 'insertDetalleVenta',
  }),
  graphql(insertVenta, {
    name: 'insertVenta',
  }),
  graphql(getUsuario)
)
class CrearDeclaracionJurada extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      nota: {
        idModeloNota: '',
        titulo: '',
        descripcion: '',
        htmlModelo: '',
      },
      persona: {},
      declaracion_jurada: '',
      ente_receptor: '',
      numero: '',
      step: 0,
      guardado: false,
      confirmado: false,
      existeVenta: false,
      loading: false,
    };

    this.guardarDatosDeclaracion = this.guardarDatosDeclaracion.bind(this);
    this.notaSeleccionada = this.notaSeleccionada.bind(this);
    this.siguientePaso = this.siguientePaso.bind(this);
    this.anteriorPaso = this.anteriorPaso.bind(this);
    this.confirmarDeclaracionJurada = this.confirmarDeclaracionJurada.bind(
      this
    );

    this.finProcesoGeneracion = this.finProcesoGeneracion.bind(this);
    this.obtenerDatosGeneracion = this.obtenerDatosGeneracion.bind(this);
    this.onImprimir = this.onImprimir.bind(this);
    this.onCancel = this.onCancel.bind(this);
  }

  guardarPersona = persona => {
    this.setState(
      {
        persona: {
          ...this.state.persona,
          ...persona,
        },
      },
      function() {
        this.siguientePaso();
      }
    );
  };

  guardarDatosDeclaracion(datos, ventaSinStock) {
    // console.log(datos);

    this.setState(
      {
        ...this.state,
        declaracion_jurada: datos.declaracion,
        ente_receptor: datos.ente_receptor,
        existeVenta: datos.existeVenta,
        detalles: datos.detalles,
        datosPosnet: datos.datosPonset,
        datosMP: datos.datosMP,
        extras: datos.extras,
      },
      function() {
        this.persistirDatos(ventaSinStock);
      }
    );
  }

  notaSeleccionada(idNota) {
    this.setState({
      ...this.state,
      nota: {
        idModeloNota: idNota,
      },
    });
  }

  obtenerDatosGeneracion() {
    //Este metodo es el encargado de, dependiendo lo necesario, de generar un unico objeto que
    //Será utilizado para pasarselo al componente generador como datos de entradas.

    let textoOperacion = `Este tramite fue exento del pago de tasa de justicia - Ley N° 1971 Art. 3 -`;
    if (this.state.declaracion && this.state.declaracion.venta) {
      let venta = this.state.declaracion.venta;
      textoOperacion = `Por este trámite se abono la suma de $${
        venta.importe
      } mediante el uso de ${
        venta.tipoPago
      }, en concepto de pago de tasa de justicia - Ley N° 1971 Art. 3 -`;
    }

    let datos = {
      ...this.state.persona,
      direccion_otro:
        this.state.persona.direccion_otro &&
        this.state.persona.direccion_otro.length > 0
          ? this.state.persona.direccion_otro
          : ' ',
      declaracion_jurada: this.state.declaracion_jurada,
      numero: this.state.numero,
      ente_receptor: this.state.ente_receptor,
      organismo: this.props.data.getUsuario.organismo,
      textoOperacion: textoOperacion,
    };

    // console.log("los datos quedan de la siguiente manera: ");
    // console.log(datos);

    return datos;
  }

  finProcesoGeneracion(textoGenerado) {
    this.setState(
      {
        ...this.state,
        nota: {
          ...this.state.nota,
          htmlModelo: textoGenerado,
        },
      },
      function() {
        //Esta es una declaracion de una funcion sincronica, que espera a que el setState se haga para ejecutarse. Un Callback
        this.siguientePaso();
      }
    );
  }

  async onImprimir(htmlFinal) {
    const rta = await this.confirmarDeclaracionJurada();

    if (rta || this.state.confirmado) {
      //TODO: IMPRIMIR
      // console.log("La respuesta es.....");
      // console.log(rta);
      imprimir(htmlFinal);
    }
  }

  async confirmarDeclaracionJurada() {
    const { confirmado, declaracion } = this.state;

    if (!confirmado) {
      try {
        const rta = await this.props.confirmarDeclaracionJurada({
          variables: {
            _id: declaracion._id,
            idModeloNota: this.state.nota.idModeloNota,
            numero: this.state.numero,
          },
        });
        if (rta) {
          notification.success({
            message: 'Declaracion Jurada Confirmada!',
            description: 'Se ha confirmado con exito la Declaracion Jurada',
          });

          this.setState({
            ...this.state,
            confirmado: true,
          });

          return rta;
        }
      } catch (err) {
        console.log('excepcion al confirmar la declaracion jurada');
        console.log(err);

        Modal.error({
          title: 'Error en la confirmacion de la declaracion jurada',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      }
    }
  }

  persistirDatos(ventaSinStock) {
    //Antes que nada, debemos verificar si ya fue guardado en la base de datos
    //Esta situacion pasaria cuando el usuario ya haya tocado el boton de imprimir antes
    //Y por alguna razon, necesita volver a imprimir (pero los datos ya fueron guardados)

    if (this.state.guardado) {
      return;
    }

    //Luego, lo primero que hacemos es, verificamos si la persona tiene id, si es asi
    // es porque vino desde el servidor, porque ya existia.
    //Entonces, no debemos crearlo.

    if (this.state.persona._id) {
      //Si ya existia la persona, creamos solo la declaracion.
      // console.log("Caso de que ya existia la persona")
      if (ventaSinStock) {
        //Esto significa que debemos generar la venta de la nueva forma.
        this.crearDeclaracionConVenta(this.state.persona._id);
      } else {
        this.crearVenta(this.state.persona._id);
      }
    }
  }

  // eslint-disable-next-line no-unused-vars
  crearVenta = idPersona => {
    let yo = this;

    let declaracion;
    let modeloDetalleVenta = {
      idTipo_Sello: null,
      cantidad: null,
    };

    let { existeVenta, datosPosnet, detalles } = this.state;
    let detallesFiltrados = [];

    detallesFiltrados = _.map(detalles, detalle => {
      let result = _.pick(detalle, _.keys(modeloDetalleVenta));

      return result;
    });
    if (existeVenta && detalles.length > 0) {
      confirm({
        title:
          'Está seguro de que desea crear la declaracion jurada CON VENTA?',
        content: 'No podrá hacer cambios sobre esta declaracion',
        onOk: () => {
          this.setState({
            loading: true,
          });
          this.props
            .insertDetalleVenta({
              variables: { detalleVenta: { detalle: detallesFiltrados } },
            })
            .then(res => {
              //El detalle de venta se inserto correctamente. Ahora debemos crear la venta..
              let detalles = res.data.insertDetalleVenta.detalle;

              let importe = _.sum(
                _.map(detalles, detalle => {
                  //Esta funcion se encarga de multiplicar la cantidad de cada de talle por el valor de cada tipo_sello
                  return detalle.cantidad * detalle.tipo_sello.valor;
                })
              );

              let venta = {
                importe: importe,
                fecha: moment().toDate(),
                idVendedor: this.props.data.getUsuario._id,
                idOrganismo: this.props.data.getUsuario.organismo._id,
                idDetalle_Venta: res.data.insertDetalleVenta._id,
                datosPosnet:
                  (datosPosnet && (datosPosnet.codigoOperacion || datosPosnet.numeroTicket))
                    ? {
                        codigoOperacion: datosPosnet.codigoOperacion,
                        numeroTicket: datosPosnet.numeroTicket,
                        cuenta: 'Tasas',
                      }
                    : null,
              };

              this.props
                .insertVenta({
                  variables: { venta: venta },
                })
                .then(res => {
                  // console.log('LA RESPUESTA DE INSER VENTA ES: ', res);
                  declaracion = {
                    fecha_creacion: new Date(),
                    declaracion: this.state.declaracion_jurada,
                    ente_receptor: this.state.ente_receptor,
                    idDeclarante: this.state.persona._id,
                    idOrganismo: this.props.data.getUsuario.organismo._id,
                    idCreador: this.props.data.getUsuario._id,
                    idVenta: res.data.insertVenta._id,
                  };

                  this.props
                    .createDeclaracion({
                      variables: { declaracion_jurada: declaracion },
                    })
                    .then(respuesta => {
                      notification.success({
                        message: 'Venta registrada',
                        description: 'La venta se registro de forma exitosa',
                      });

                      notification.success({
                        message: 'Nueva Declaracion Jurada',
                        description:
                          'Se ha registrado con exito la declaracion',
                      });

                      this.setState(
                        {
                          ...this.state,
                          declaracion: {
                            ...this.state.declaracion,
                            ...respuesta.data.insertDeclaracionJurada,
                          },
                          guardado: true,
                          loading: false,
                        },
                        () => {
                          this.siguientePaso();
                        }
                      );
                    })
                    .catch(error => {
                      console.log('Excepcion!!');
                      console.log(error);
                      this.setState({
                        loading: false,
                      });

                      errorService(error, {
                        declaracion_jurada: declaracion,
                      });

                      Modal.error({
                        title: 'Error en la creacion de la declaracion jurada',
                        content:
                          'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
                      });
                    });
                  return res;
                })
                .catch(err => {
                  console.log('Se ha producido un error');
                  console.log(err);
                  errorService(err, {
                    venta: venta,
                  });
                  this.setState({
                    loading: false,
                  });
                  notification.error({
                    message: 'Error al registrar la venta',
                    description:
                      'Se ha producido un error al registrar la venta',
                  });

                  return err;
                });
            })
            .catch(err => {
              console.log(
                'Ocurrio un error a la hora de registrar el detalle de la venta'
              );
              console.log(err);
              errorService(err, {
                detalleVenta: { detalle: detallesFiltrados },
              });
              this.setState({
                loading: false,
              });

              Modal.error({
                title:
                  'Error en la creacion de la venta, compruebe que exista stock por favor',
                content:
                  'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
              });
            });
        },
        onCancel() {
          console.log('Cancel');

          errorService(
            new Error(
              'CANCELO LA CREACION DEL TRAMITE DECLARACION "CON VENTA" '
            ),
            {
              respuestaServer: yo.state,
              existeVenta: existeVenta,
            }
          );
          yo.setState({
            loading: false,
          });
        },
      });
    } else {
      //caso donde solo debo crear la certificacion:

      declaracion = {
        fecha_creacion: new Date(),
        declaracion: this.state.declaracion_jurada,
        ente_receptor: this.state.ente_receptor,
        idDeclarante: this.state.persona._id,
        idOrganismo: this.props.data.getUsuario.organismo._id,
        idCreador: this.props.data.getUsuario._id,
      };

      confirm({
        title:
          'Está seguro de que desea crear la declaracion jurada SIN VENTA?',
        content: 'No podrá hacer cambios sobre esta declaracion',
        onOk: () => {
          this.props
            .createDeclaracion({
              variables: { declaracion_jurada: declaracion },
            })
            .then(respuesta => {
              notification.success({
                message: 'Nueva Declaracion Jurada',
                description: 'Se ha registrado con exito la declaracion',
              });

              this.setState(
                {
                  ...this.state,
                  declaracion: {
                    ...this.state.declaracion,
                    ...respuesta.data.insertDeclaracionJurada,
                  },
                  guardado: true,
                  loading: false,
                },
                () => {
                  this.siguientePaso();
                }
              );
            })
            .catch(error => {
              console.log('Excepcion!!');
              console.log(error);
              this.setState({
                loading: false,
              });

              Modal.error({
                title: 'Error en la creacion de la declaracion jurada',
                content:
                  'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
              });
            });
        },
        onCancel() {
          console.log('Cancel');
          errorService(
            new Error(
              'CANCELO LA CREACION DEL TRAMITE DECLARACION "SIN VENTA" '
            ),
            {
              respuestaServer: yo.state,
              existeVenta: existeVenta,
              declaracion,
            }
          );
          yo.setState({
            loading: false,
          });
        },
      });
    }
  };

  // eslint-disable-next-line no-unused-vars
  crearDeclaracionConVenta = id => {
    let declaracion;
    let modeloDetalleVenta = {
      idTipo_Sello: null,
      cantidad: null,
    };
    const { existeVenta, datosPosnet, detalles, extras, datosMP } = this.state;
    let detallesFiltrados = _.map(detalles, detalle => {
      let result = _.pick(detalle, _.keys(modeloDetalleVenta));

      return result;
    });
    let { email, enviarPorEmail, descargarRecibo } = extras;
    let venta;

    if (existeVenta && detalles.length > 0) {
      venta = {
        idVendedor: this.props.data.getUsuario._id,
        idOrganismo: this.props.data.getUsuario.organismo._id,
        detalle: detallesFiltrados,
        datosPosnet:
          (datosPosnet && (datosPosnet.codigoOperacion || datosPosnet.numeroTicket))
            ? {
                codigoOperacion: datosPosnet.codigoOperacion,
                numeroTicket: datosPosnet.numeroTicket,
                cuenta: 'Tasas',
              }
            : null,
        datosMP: datosMP
          ? { numeroComprobante: datosMP.numeroComprobante }
          : null,
        datosRecibo: {
          email,
          enviarPorEmail,
          descargarRecibo,
        },
      };
    }
    //El detalle de venta se inserto correctamente. Ahora debemos crear la venta..

    declaracion = {
      fecha_creacion: new Date(),
      declaracion: this.state.declaracion_jurada,
      ente_receptor: this.state.ente_receptor,
      idDeclarante: this.state.persona._id,
      idOrganismo: this.props.data.getUsuario.organismo._id,
      idCreador: this.props.data.getUsuario._id,
    };

    console.log('DATOS DE LA DECLARACION: ', venta, declaracion);

    this.props
      .crearDeclaracionJurada({
        variables: { declaracion_jurada: declaracion, venta: venta },
      })
      .then(respuesta => {
        notification.success({
          message: 'Venta registrada',
          description: 'La venta se registro de forma exitosa',
        });

        notification.success({
          message: 'Nueva Declaracion Jurada',
          description: 'Se ha registrado con exito la declaracion',
        });

        if (
          descargarRecibo &&
          respuesta.data.crearDeclaracionJurada &&
          respuesta.data.crearDeclaracionJurada.venta &&
          respuesta.data.crearDeclaracionJurada.venta.recibo64
        ) {
          verPdf(
            respuesta.data.crearDeclaracionJurada.venta.recibo64,
            `Recibo_Num_${respuesta.data.crearDeclaracionJurada.venta.id}`
          );
        }

        this.setState(
          {
            ...this.state,
            declaracion: {
              ...this.state.declaracion,
              ...respuesta.data.crearDeclaracionJurada,
            },
            guardado: true,
            loading: false,
          },
          () => {
            this.siguientePaso();
          }
        );
      })
      .catch(error => {
        console.log('Excepcion!!');
        console.log(error);
        this.setState({
          loading: false,
        });

        errorService(error, {
          declaracion_jurada: declaracion,
        });

        Modal.error({
          title: 'Error en la creacion de la declaracion jurada',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });
  };

  ModeloNotaElegido = idNota => {
    // console.log("La nota tiene el id de ....", idNota.modelo);
    // console.log("La nota tiene el id de ....", this.state.nota.idModeloNota);

    this.setState(
      {
        ...this.state,
        nota: {
          ...this.state.nota,
          idModeloNota: idNota.modelo,
        },
        loading: true,
      },
      () => {
        // console.log("Entre!");

        this.props.client
          .mutate({
            mutation: obtenerNumeroTalonario,
            variables: {
              idModeloNota: this.state.nota.idModeloNota,
            },
          })
          .then(respuesta => {
            // console.log("Recibi de respuesta....");
            // console.log(respuesta);

            if (respuesta.data.obtenerNumeroTalonario == -1) {
              notification.warning({
                message: 'Talonario no configurado',
                description:
                  'El modelo de nota no tiene configurado el talonario a usar',
              });
            }

            this.setState({
              ...this.state,
              numero: respuesta.data.obtenerNumeroTalonario
                ? respuesta.data.obtenerNumeroTalonario
                : 0,
              loading: false,
            });

            // console.log("ESTADO: ");
            // console.log(this.state);
            this.siguientePaso();
          })
          .catch(err => {
            console.log('ERROR a la hora de obtener el numero del  talonario');
            console.log(err);
            this.setState({
              loading: false,
            });
          });
      }
    );
  };

  onCancel() {
    //El cancelar reinicia todo el estado de la aplicacion para volver a empezar desde 0
    this.setState({
      nota: {
        idModeloNota: '',
        titulo: '',
        descripcion: '',
        htmlModelo: '',
      },
      persona: {},
      declaracion_jurada: '',
      ente_receptor: '',
      numero: '',
      guardado: false,
      confirmado: false,
      existeVenta: false,
      step: 0,
    });
    this.props.history.push('/');
  }

  siguientePaso() {
    //Metodo que se encarga de aumentar en 1 el paso y es llamado por todos los metodos auxiliares
    let paso = this.state.step;
    paso++;
    this.setState({
      ...this.state,
      step: paso,
    });
  }

  anteriorPaso() {
    let paso = this.state.step;
    if (paso > 0) {
      paso--;
      this.setState({
        ...this.state,
        step: paso,
      });
    }
  }

  render() {
    const { Step } = Steps;
    let { step } = this.state;

    if (this.state.loading) {
      return <Loading />;
    }

    return (
      <div>
        <Breadcrumb
          style={{
            margin: '12px 0',
          }}
        >
          <Breadcrumb.Item>Declaracion Jurada</Breadcrumb.Item>
          <Breadcrumb.Item>Nueva</Breadcrumb.Item>
        </Breadcrumb>
        <Layout
          style={{
            background: '#fff',
            padding: 24,
            minHeight: '80vh',
          }}
        >
          <h2 style={{ marginBottom: 10, textAlign: 'center' }}>
            <Icons.FileTextOutlined /> Nueva Declaracion Jurada
          </h2>
          <br />
          <Steps size="small" className="stepsFormularios" current={step}>
            <Step title="Buscar Persona" />
            <Step title="Declaracion" />
            <Step title="Modelo Nota" />
            <Step title="Generacion de Nota" />
            <Step title="Editar e Imprimir" />
          </Steps>
          <div style={estiloContent}>
            {step === 0 && (
              <BuscarYCrearPersona obtenerPersona={this.guardarPersona} />
            )}

            {step === 1 && (
              <FormDeclaracionJurada
                organismo={this.props.data.getUsuario.organismo}
                onFinalizar={(datos, ventaSinStock) =>
                  this.setState({ loading: true }, () =>
                    this.guardarDatosDeclaracion(datos, ventaSinStock)
                  )
                }
                onSubmit={(datos, ventaSinStock) =>
                  this.setState({ loading: true }, () =>
                    this.guardarDatosDeclaracion(datos, ventaSinStock)
                  )
                }
                config={{ creacion: true }}
                datos={{
                  declaracion: this.state.declaracion_jurada,
                  ente_receptor: this.state.ente_receptor,
                }}
              />
            )}

            {step === 2 && (
              <SelectorModelo
                handleChange={this.notaSeleccionada}
                onSubmit={this.ModeloNotaElegido}
              />
            )}
            {step === 3 && (
              <Generador
                id={this.state.nota.idModeloNota}
                // datos={this.state.persona}
                datos={this.obtenerDatosGeneracion()}
                mostrarEditor={this.finProcesoGeneracion}
              />
            )}
            {step === 4 && (
              <CKEditor
                modelo_nota={this.state.nota}
                onImprimir={this.onImprimir}
                onGuardar={this.confirmarDeclaracionJurada}
                onCancel={this.onCancel}
                accion="visualizar"
              />
            )}
          </div>
        </Layout>
      </div>
    );
  }
}

export default withApollo(CrearDeclaracionJurada);
